<template>
  <article class="  card-categorei category__box" v-if="data">
    <router-link :class="{ them2: them == 2 }" class="category__box__link"
      :to="`/products/category/${data.id}/${data.slug}`">
      <figure class="figure-image" v-if="data.image">
        <img class="img" width="195" height="195" decoding="async" loading="lazy" :title="data.title"
          :src="data.image.url" :alt="data.title" />
      </figure>
      <skeleton v-else class="w-100" style="height: 200px;" />
      <div class="info">
        <p>
          {{ data.title }}
        </p>
      </div>
    </router-link>
  </article>

</template>

<script>
import DynamicLinker from "@/parts/Front/components/shared/DynamicLinker";
import skeleton from "@/parts/Front/components/shared/skeleton"
export default {
  name: "HomeCategoreis_card",
  components: { DynamicLinker, skeleton },
  props: {
    data: Object,
    them: {
      type: Number,
      default: 1,
    },
  },
};
</script>
<style scoped>
.card-categorei {
  width: 100px;
  height: fit-content;
}

.category__box__link {
  color: #000;
}


.category__box {
  display: inline-block;
  width: 100%;
  transition: all 0.5s 0.2s;

  overflow: hidden;
}

.figure-image {
  margin: 0;
  padding-bottom: 0;
  position: relative;
  overflow: hidden;
}

.img {
  width: 100%;
  height: auto;
  transition: all 0.5s 0.3s;
  border-radius: 14px;
}

.them2 .img,
.them2 {
  border-radius: unset !important;
}

@media (max-width: 480px) {
  .them2 .img {
    height: 150px;
  }
}

.them2 .figure-image::before {
  content: "";
  left: -70%;
  background: hsla(0, 0%, 100%, 0.4);
  width: 25%;
  height: 100%;
  top: 0;
  transform: translateY(calc(-50% - 2px));
  transform: skew(-45deg);
  position: absolute;
  transition: right 0.5s ease-in;

  z-index: 100;
}

.them2:hover .figure-image::before {
  left: 150%;
}

.info {
  margin-top: 12px;
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 12px 0;
  font-weight: 900;

  transition: 0.75s;
  border-radius: 8px;
  overflow: hidden;
  z-index: 1;
}

.info::after {
  position: absolute;
  content: "";
  display: block;
  left: -25%;
  right: -10%;
  top: -4%;
  height: 150%;
  width: 150%;
  bottom: 0;
  background-color: var(--newTheme-color);
  transform-origin: right;
  transform: skewX(-45deg) scale(0, 1);
  z-index: -1;
  transition: transform 0.75s;
}

.info p {
  margin: 0;
  transition: all 0.75s;
}

.category__box:hover .info::after {
  transform: skewX(-45deg) scale(1, 1);
  transform-origin: left;
  transition: transform 0.75s;
}

.category__box:hover .info p {
  color: #fff;
}

@media screen and (max-width: 1080px) {


  .category__box {
    margin-top: 9px;
    margin-bottom: 9px;
  }
}

@media screen and (max-width: 500px) {
  .info p {
    font-size: 12px;
  }
}
</style>
